module.exports = __webpack_public_path__ + "img/pin2.78eb1895.svg";